import { render, staticRenderFns } from "./memorialHall_image.vue?vue&type=template&id=12794c1b&scoped=true"
import script from "./memorialHall_image.vue?vue&type=script&lang=js"
export * from "./memorialHall_image.vue?vue&type=script&lang=js"
import style0 from "./memorialHall_image.vue?vue&type=style&index=0&id=12794c1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12794c1b",
  null
  
)

export default component.exports